class AuthService {
  constructor() {
    this.token = window.localStorage.getItem("asteria_token");
    this.user = JSON.parse(window.localStorage.getItem("asteria_user"));
  }

  check() {
    return !!this.token;
  }

  setUser(user) {
    window.localStorage.removeItem("asteria_user");
    window.localStorage.setItem("asteria_user", JSON.stringify(user));
    this.user = user;
    location.reload();
  }

  login(token, user) {
    window.localStorage.setItem("asteria_token", token);
    window.localStorage.setItem("asteria_user", JSON.stringify(user));
    this.token = token;
    this.user = user;
    location.reload();
  }

  logout() {
    window.localStorage.removeItem("asteria_token");
    window.localStorage.removeItem("asteria_user");
    location.reload();
  }
}

export default new AuthService();
